const Sentry = require('@sentry/node')
const { getCookie } = require('cookies-next')

function captureException(err, context = 'global', options = {}) {
  const { req, res, extra } = options
  Sentry.configureScope(scope => {
    if (err.message) {
      // De-duplication currently doesn't work correctly for SSR / browser errors
      // so we force deduplication by error message if it is present
      scope.setFingerprint([err.message])
    }

    if (err.statusCode) {
      scope.setExtra('statusCode', err.statusCode)
    }

    if (res && res.statusCode) {
      scope.setExtra('statusCode', res.statusCode)
    }

    if (process.browser) {
      scope.setTag('ssr', false)

      const userId = getCookie(process.env.NEXT_PUBLIC_USER_ID_COOKIE_NAME)

      if (userId) {
        scope.setUser({ id: userId })
      }
    } else {
      scope.setTag('ssr', true)

      if (req) {
        scope.setExtra('url', req.url)
        scope.setExtra('params', req.params)
        scope.setExtra('query', req.query)
        scope.setExtra('headers', req.headers)

        const userId = getCookie('userId', { req, res })

        if (userId) {
          scope.setUser({ id: userId })
        }
      }
    }

    if (extra) {
      Object.keys(extra).forEach(key => {
        scope.setExtra(key, extra[key])
      })
    }

    scope.setTag('context', context)
  })

  Sentry.captureException(err)
}

module.exports = {
  captureException,
}
